<template>
  <Addition v-if="isAddition">
    <template #field>{{ change.field.name }}</template>
    <p>{{ newDate }}</p>
  </Addition>
  <Removal v-else-if="isRemoval">
    <template #field>{{ change.field.name }}</template>
    <p class="old-value">{{ oldDate }}</p>
  </Removal>
  <Change v-else-if="isChange">
    <template #field>{{ change.field.name }}</template>
    <template #old>
      <p>{{ oldDate }}</p>
    </template>
    <template #new>
      <p class="new-value">{{ newDate }}</p>
    </template>
  </Change>
</template>

<script>
import moment from "moment";
import { EXTERNAL_CHANGES_TYPE } from "@/enums/external-changes";
import { FORMAT } from "@/config/date-format";

import Addition from "@/components/ExternalChanges/general/Addition.vue";
import Removal from "@/components/ExternalChanges/general/Removal.vue";
import Change from "@/components/ExternalChanges/general/Change.vue";

export default {
  name: "OpeningDateChange",
  props: {
    change: {
      type: Object,
      required: true
    }
  },
  components: { Addition, Removal, Change },

  computed: {
    isAddition() {
      return this.change && this.change.type
        ? this.change.type === EXTERNAL_CHANGES_TYPE.ADDITION &&
            this.change.new_value
        : false;
    },
    isRemoval() {
      return this.change && this.change.type
        ? this.change.type === EXTERNAL_CHANGES_TYPE.REMOVAL &&
            this.change.old_value
        : false;
    },
    isChange() {
      return this.change && this.change.type
        ? this.change.type === EXTERNAL_CHANGES_TYPE.CHANGE &&
            this.change.new_value &&
            this.change.old_value
        : false;
    },
    oldDate() {
      return this.change.old_value &&
        this.change.old_value.day &&
        this.change.old_value.month &&
        this.change.old_value.year
        ? moment({
            ...this.change.old_value,
            month: this.change.old_value.month - 1
          }).format(FORMAT.DATE)
        : this.change.old_value &&
          this.change.old_value.month &&
          this.change.old_value.year
        ? `${this.change.old_value.year}-${
            this.change.old_value.month < 10
              ? "0" + this.change.old_value.month
              : this.change.old_value.month
          }`
        : "-";
    },
    newDate() {
      return this.change.new_value &&
        this.change.new_value.day &&
        this.change.new_value.month &&
        this.change.new_value.year
        ? moment({
            ...this.change.new_value,
            month: this.change.new_value.month - 1
          }).format(FORMAT.DATE)
        : this.change.new_value &&
          this.change.new_value.month &&
          this.change.new_value.year
        ? `${this.change.new_value.year}-${
            this.change.new_value.month < 10
              ? "0" + this.change.new_value.month
              : this.change.new_value.month
          }`
        : "-";
    }
  }
};
</script>

<style lang="scss" scoped>
.new-value {
  font-weight: bold;
}

.old-value {
  text-decoration: line-through;
}
</style>
